import styled from 'styled-components';

export const StyledImage = styled.img`
    width: ${(props) => (props.width ? props.width : 'auto')};
    ${(props) => (props.responsive ? `max-width: 100%;` : ``)};
    height: ${(props) => (props.height ? props.height : 'auto')};
`;
